export default __webpack_public_path__ + "static/media/y_sprint.987ab5d9.png";